import { render, staticRenderFns } from "./ReliabilityTable.vue?vue&type=template&id=20755f96&scoped=true"
import script from "./ReliabilityTable.vue?vue&type=script&lang=js"
export * from "./ReliabilityTable.vue?vue&type=script&lang=js"
import style0 from "./ReliabilityTable.vue?vue&type=style&index=0&id=20755f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20755f96",
  null
  
)

export default component.exports